// extracted by mini-css-extract-plugin
export default {"productCarousel":"n2-z"};